export const EVENT = Object.freeze({
  SUBMIT: `suggestion-submit`,
  ADD_NEW_CONVERSATION: `add-new-conversation`,
  RESET_ACTIVE_CONVERSATION: `reset-active-conversation`,
  RECORD_SUCCESS: 'record-success',
  ERROR: 'error-report',
});
